var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 15C2.23858 15 0 17.2386 0 20C0 22.7614 2.23858 25 5 25H95C97.7614 25 100 22.7614 100 20C100 17.2386 97.7614 15 95 15H5Z","key":0}),React.createElement("path",{"d":"M0 50C0 47.2386 2.23858 45 5 45H73C75.7614 45 78 47.2386 78 50C78 52.7614 75.7614 55 73 55H5C2.23858 55 0 52.7614 0 50Z","key":1}),React.createElement("path",{"d":"M0 80C0 77.2386 2.23858 75 5 75H46.7386C49.5 75 51.7386 77.2386 51.7386 80C51.7386 82.7614 49.5 85 46.7386 85H5C2.23858 85 0 82.7614 0 80Z","key":2})]);
}

Menu.defaultProps = {"viewBox":"0 0 100 100","fill":"currentColor"};

module.exports = Menu;

Menu.default = Menu;
